import CompleteRedirectForm from './CompleteRedirectForm';
import CompleteRedirectFormContainer from './CompleteRedirectForm.container';
export default CompleteRedirectFormContainer(CompleteRedirectForm);
